import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  videoModalTitle: {
    id: 'catalog.home-page.video-modal-title',
    defaultMessage: 'Video',
    description: 'Title text displayed inside the modal when the promo video is opened.',
  },
  videoIframeTitle: {
    id: 'catalog.home-page.video-iframe-title',
    defaultMessage: 'YouTube video player',
    description: 'Title attribute for the embedded YouTube iframe video player.',
  },
});

export default messages;
